import { Box, Grid, CardContent, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import CardUpdates from "../card/CardUpdates";
import axios from "axios";
// import '../../interceptors/axios'


const Updates = ({sendPage}) => {

    const [updatesData, setUpdatesData] = useState([])

    useEffect(() => {
        sendPage("updates")

        const fetchUpdatesData = async () => {
          // const API = axios.create({
          //   baseURL: process.env.REACT_APP_API_URL,
          //   withCredentials: true,
          // })
          
          // API.defaults.headers.common['Authorization'] = `Bearer ${token}`;

          try {            

        //   console.log("slug: " + slug)
          // if (typeof slug == 'undefined') {return (null);}
          const token = localStorage.getItem("token");
          const updates_data = await axios.get(
            `${process.env.REACT_APP_API_URL}/updates/`, 
            {headers: {'Authorization': `Bearer ${token}`},})
          setUpdatesData(updates_data.data)

          } catch (error) {
            // console.log("Error during updates data fetch")
          }
        }

        fetchUpdatesData()
      }, [])

      return (
        <Box sx={{
            backgroundColor: '#5C7373',
            backgroundPosition: 'center',
            width: '100%'
        }}>
        <Typography
        height={150}
        align="center"
        color={"white"}
        variant="h2"
        sx={{ fontWeight: 900, top: 40, position: 'relative', textShadow: '4px 4px black', fontFamily: 'Light-1' }}>
            Updates
        </Typography>
        <Box
            display="flex"
            justifyContent="center"
            sx={{
                backgroundColor: '#5C7373',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                justifyContent: "center",
            }}>
            {updatesData.map( update => (
                <CardContent >
                <hr />
                    <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                        <Grid item
                            align={'center'}
                            display={'flex'}
                            position={'relative'}
                            >
                            <CardUpdates 
                                updateImageId={update.id} 
                                updateTitle={update.title} 
                                updateContent={update.content}
                                updateDate={update.day} />
                        </Grid>
                    </Grid>
                <hr />
                </CardContent>
            ))
        }
        </Box>
        </Box>
      );
};

export default Updates;